import { matchPath, useLocation} from "react-router-dom";
import { useMemo} from "react";
import {Paths} from "components/common/navigation";


export default function useGlobalSearchEnabled() {
    const {pathname} = useLocation();

    return useMemo(() => {
        return matchPath(Paths.CONTACT, pathname) !== null
            || matchPath(Paths.ADVERTISING, pathname) !== null
            || matchPath(Paths.FILM, pathname) !== null
            || matchPath(Paths.ADMIN_TAGS, pathname) !== null;
    }, [pathname]);
}
